import {NgModule} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import {Ng2DynamicStateDeclaration, dynamicStateConfigFn} from '@ngx-ivengi/locale';
import {PlaceholderComponent} from '../shared/placeholder.component';
import {ThroughputFormComponent} from './throughput-form.component';


export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'assignment.survey.edit.channel.edit.throughput',
    future: true,
    abstract: true,
    component: PlaceholderComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.channel.edit.throughput.pageTitle',
      scopes: ['throughput:create']
    }
  },
  {
    name: 'assignment.survey.edit.channel.edit.throughput.add',
    future: true,
    component: ThroughputFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.channel.edit.throughput.add.pageTitle',
      scopes: ['throughput:create']
    }
  },
  {
    name: 'assignment.survey.edit.channel.edit.throughput.edit',
    future: true,
    component: ThroughputFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.channel.edit.throughput.edit.pageTitle',
      scopes: ['throughput:update']
    }
  },
  {
    name: 'assignment.execution.edit.channel.edit.throughput',
    abstract: true,
    future: true,
    component: PlaceholderComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.channel.edit.throughput.pageTitle',
      scopes: ['throughput:create']
    }
  },
  {
    name: 'assignment.execution.edit.channel.edit.throughput.add',
    future: true,
    component: ThroughputFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.channel.edit.throughput.add.pageTitle',
      scopes: ['throughput:create']
    }
  },
  {
    name: 'assignment.execution.edit.channel.edit.throughput.edit',
    future: true,
    component: ThroughputFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.channel.edit.throughput.edit.pageTitle',
      scopes: ['throughput:update']
    }
  },
  {
    name: 'assignment.maintenance.edit.channel.edit.throughput',
    abstract: true,
    future: true,
    component: PlaceholderComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.channel.edit.throughput.pageTitle',
      scopes: ['throughput:create']
    }
  },
  {
    name: 'assignment.maintenance.edit.channel.edit.throughput.add',
    future: true,
    component: ThroughputFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.channel.edit.throughput.add.pageTitle',
      scopes: ['throughput:create']
    }
  },
  {
    name: 'assignment.maintenance.edit.channel.edit.throughput.edit',
    future: true,
    component: ThroughputFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.channel.edit.throughput.edit.pageTitle',
      scopes: ['throughput:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    })
  ]
})
export class ThroughputRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/throughput/throughput.routes.ts